<template>
  <div class="suga-manage-page">
    <header class="console-page-head">
      <div class="console-page-copy">
        <p class="console-kicker">설정</p>
        <h2 class="console-title">수가변경</h2>
        <p class="console-desc">사업·연도별 수가 구간입니다. 예산의 급여총액과 본인부담에 이 값이 쓰입니다.</p>
      </div>
    </header>
    <BudgetSugaInfoModal />
  </div>
</template>

<script setup lang="ts">
import BudgetSugaInfoModal from "@/components/budget/BudgetSugaInfoModal.vue";
</script>
